<template>
  <div class="fvlr box" :class="{ borderBottom: showBorder }">
    <div class="title themeColor">{{ title }}</div>
    <div class="more themeColor underline" @click="moreFn">{{ more }}</div>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'

export default {
  props: ['datas'],
  setup(props, { emit }) {
    let { datas } = toRefs(props)
    let { title, more, showBorder } = datas.value
    const state = reactive({
      count: 0
    })
    let moreFn = () => {
      emit('handle')
    }
    return {
      ...toRefs(state),
      title,
      more,
      moreFn,
      showBorder
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding-bottom: 10px;
}
.borderBottom {
  border-bottom: 1px solid #999;
}
.title {
  font-size: 14px;
  font-weight: bold;
}
.more {
  font-size: 12px;
}
</style>
